export default __webpack_public_path__ + "static/media/No_coach.94f20d7f.svg";